// 📂 src/hooks/useAuth.ts
import { useState, useEffect } from "react";
import {UserApi} from "../API/userApi";

const useAuth = () => {
  const [user, setUser] = useState(UserApi.getUserFromStorage());

  useEffect(() => {
    setUser(UserApi.getUserFromStorage());
  }, []);

  return { user, setUser };
};

export default useAuth;
